<forge-app-bar [titleText]="'Inmate Records Search ' + (siteTitle$ | async)" class="forge-app-bar-custom" slot="header">
  <forge-app-bar-menu-button  (click)="menuBtnClicked.next()" slot="start" *ngIf="userService.hasInstanceAdminRole$ | async"></forge-app-bar-menu-button>
  @if (logo$ | async) {
    <img [src]="(logo$ | async)" slot="logo" alt="logo">
  }

  <forge-icon-button slot="end" (click)="handleThemeButtonClick()" aria-label="Theme" type="button">
    <forge-icon [name]="themeIcon"></forge-icon>
    <forge-tooltip position="bottom">Theme</forge-tooltip>
  </forge-icon-button>

  <ng-container *ngIf="activeInstanceName$ | async">
    <forge-icon-button slot="end" *ngIf="(instances$ | async)?.length ?? 0 > 0" type="button"
                       aria-label="Switch instance"
                       #instancePopup="forgePopover"
                       [forgePopover]="instanceListTemplate"
                       (click)="instancePopup.open()">
      <forge-icon name="location_city"></forge-icon>
      <forge-tooltip position="bottom">Switch instance</forge-tooltip>
    </forge-icon-button>

    <ng-template #instanceListTemplate>
      <!--suppress AngularBindingTypeMismatch -->
      <forge-popover placement="bottom-end">
        <div class="instance-popup">
          <forge-list role="list">
            <forge-list-item role="none" *ngFor="let instance of instances$ | async"
                             (click)="handelInstanceItemClick(instance)"
                             [selected]="instance.instanceId === (activeInstanceId$ | async)">
              {{instance.name}}
            </forge-list-item>
          </forge-list>
        </div>
      </forge-popover>
    </ng-template>

    <forge-app-bar-profile-button
      (forge-profile-card-sign-out)="handleSignOutButtonCLick()"
      [avatarText]="(user$ | async)?.name"
      [email]="(user$ | async)?.email"
      [fullName]="(user$ | async)?.name"
      slot="end">
    </forge-app-bar-profile-button>
  </ng-container>
</forge-app-bar>